import React from 'react'

export default function MovieByLanguage() {
  return (
    <div>MovieByLanguage</div>
  )
}
